import script from "./nickname-input.vue?vue&type=script&lang=ts&setup=true"
export * from "./nickname-input.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__